import React, {useEffect} from 'react';
import LoginScreen from "./LoginScreen";
import {useHistory, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from "../../redux";
import {signInAsync} from "../../redux/account/signInModule";
import {SignInRequest} from "../../api/signIn";
import {LINK_TANK} from "../../resources/LinkConstants";


interface LoginComponentProps {

}

function LoginContainer(props: LoginComponentProps) {

    const {data, loading} = useSelector((state: RootState) => state.accountReducers.signInReducer.signInResponse);

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    function onConfirm(request: SignInRequest) {
        dispatch(signInAsync.request(request));
    }

    useEffect(() => {
            if (data != null) {
                if (location.state?.referrer?.pathname != null) {
                    history.replace(location.state.referrer.pathname)
                } else {
                    history.replace(LINK_TANK)
                }
            }
        }
    )

    return (
        <>
            <LoginScreen onConfirmClick={onConfirm} loading={loading}/>
        </>
    )
}

export default LoginContainer